import { ProductUserViewEnum } from "@saleor/types/globalTypes";

import { ProductsUser } from "../customTypes/ProductsUser";
import {
  ProductListUrlQueryParams,
  ProductMainCreateUrlQueryParams
} from "../urls";

export default function getProductAddUrlByUserType(
  productUser: ProductsUser,
  productAddUrlCallback: (params?: ProductMainCreateUrlQueryParams) => string,
  params: ProductListUrlQueryParams
) {
  if (productUser.isKAMS) {
    return productAddUrlCallback({
      brand: params.brand,
      viewAs: params.viewAs as ProductUserViewEnum
    });
  }
  return productAddUrlCallback();
}
